import React from 'react';
import { Box, Paper, Typography, Button, IconButton } from '@mui/material';
import { NotificationsActive, Close } from '@mui/icons-material';
import { useNotifications } from '../../contexts/NotificationContext';

/**
 * A banner that prompts the user to enable push notifications.
 * Shown once after login if the browser permission state is "default".
 * The user can accept (triggering the browser permission dialog) or dismiss.
 */
export default function NotificationPermissionPrompt() {
  const { showPermissionPrompt, subscribeToPush, dismissPermissionPrompt } = useNotifications();

  if (!showPermissionPrompt) return null;

  const handleEnable = async () => {
    await subscribeToPush();
  };

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1400,
        maxWidth: 440,
        width: 'calc(100% - 32px)',
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        borderRadius: 3,
        bgcolor: '#1A1D1F',
        color: '#fff',
        border: '1px solid rgba(210, 255, 0, 0.3)',
      }}
    >
      <NotificationsActive sx={{ color: '#D2FF00', fontSize: 32 }} />

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle2" fontWeight={700}>
          Stay in the loop!
        </Typography>
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
          Enable notifications to get alerts for new announcements, recognition &amp; more.
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="small"
        onClick={handleEnable}
        sx={{
          bgcolor: '#D2FF00',
          color: '#1A1D1F',
          fontWeight: 700,
          textTransform: 'none',
          whiteSpace: 'nowrap',
          '&:hover': { bgcolor: '#b8e000' },
        }}
      >
        Enable
      </Button>

      <IconButton size="small" onClick={dismissPermissionPrompt} sx={{ color: 'rgba(255,255,255,0.5)' }}>
        <Close fontSize="small" />
      </IconButton>
    </Paper>
  );
}
